import { InfoPagePrivacyParagraph } from './InfoPagePrivacyParagraph.style';

export default InfoPagePrivacyParagraph;
